import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IClient, IClientContact, IClientsFilter } from "./clients.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../env-config";
@Injectable()
export class ClientsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  getClients(filter?: IClientsFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_CLIENTS)}${queryParams}`);
  }

  getClientsCount(filter?: IClientsFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_CLIENTS)}/count${queryParams}`);
  }

  getClient(client: IClient | string): Observable<any> {
    let id = (typeof client == 'string') ? client : client._id;
    return this._http.get(`${apiURL(EnvConfig.API_CLIENTS)}/${id}`);
  }

  getClientsSimilar(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_CLIENTS)}/similar${queryParams}`);
  }

  createClient(client: IClient): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_CLIENTS)}`, client);
  }

  updateClient(client: IClient): Observable<any> {
    let id = client._id;
    delete client._id;
    return this._http.patch(`${apiURL(EnvConfig.API_CLIENTS)}/${id}`, client);
  }

  deleteClient(client: IClient | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof client == 'string') ? client : client._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_CLIENTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_CLIENTS)}/${id}/delete`);
  }

  restoreClient(client: IClient | string): Observable<void> {
    let id = (typeof client == 'string') ? client : client._id;
    return this._http.post(`${apiURL(EnvConfig.API_CLIENTS)}/${id}/restore`, null);
  }

  createClientContact(contact: IClientContact): Observable<IClientContact> {
    let data: any = _.cloneDeep(contact);
    data.company = this._AuthService.companyId();
    return this._http.post(`${apiURL(EnvConfig.API_CLIENT_CONTACTS)}`, data);
  }

  updateClientContact(contact: IClientContact): Observable<any> {
    let id = contact._id;
    let data: any = _.cloneDeep(contact);
    delete data._id;
    data.company = this._AuthService.companyId();
    return this._http.patch(`${apiURL(EnvConfig.API_CLIENT_CONTACTS)}/${id}`, data);
  }
}